import { helper } from "@ember/component/helper";
import { isNone } from "@ember/utils";

export default helper(function valueOrDefault([value, defaultTo]) {
  return isNone(value) ? defaultTo : value;
});
